export default class WorkPlanReviewPhaseCtrl {
  constructor ($scope, $timeout, $stateParams, WorkPlanSrv, $cookies, $rootScope,$interval) {
    const workplanReviewVM = this;
        
    $rootScope.fullscreenClass = 'background-planning'
    workplanReviewVM.filter = filter;
    workplanReviewVM.singleFilter = singleFilter;
    
    // Grid definition
    
    workplanReviewVM.gridOptions = {
      enableFiltering: true,
      columnDefs: [
        {
          displayName: 'Nombre Profesor',
          name: 'Nombre Profesor',
          field: 'ds_name',
          width: '25%',
          enableGridMenu: false,
          enableHiding: false,
          enableFiltering: false,
          enablePinning: false,
          enableColumnMenu: false,
          enableSorting: false
        }, {
          displayName: 'Plan de Trabajo asignado',
          name: 'Plan de Trabajo asignado',
          field: 'workplan_name',
          width: '25%',
          enableGridMenu: false,
          enableHiding: false,
          enableFiltering: false,
          enablePinning: false,
          enableColumnMenu: false,
          enableSorting: false
        }, {
          displayName: 'Estado',
          name: 'Estado',
          field: 'state_name',
          width: '25%',
          enableGridMenu: false,
          enableHiding: false,
          enableFiltering: false,
          enablePinning: false,
          enableColumnMenu: false,
          enableSorting: true,
        }, {
          displayName: 'Acciones',
          name: 'Acciones',
          field: 'id_state',
          width: '25%',
          enableGridMenu: false,
          enableHiding: false,
          enableFiltering: false,
          enablePinning: false,
          enableColumnMenu: false,
          enableSorting: false,
          headerCellClass: 'column-center',
          cellTemplate: require('./cellTemplateWorkPlanActions.html')
        }
      ],
      onRegisterApi: (gridApi) => {
        workplanReviewVM.gridApi = gridApi
        workplanReviewVM.gridApi.grid.registerRowsProcessor( workplanReviewVM.singleFilter, 200 );
        $interval(function () {
          workplanReviewVM.gridApi.core.handleWindowResize()
        }, 500, 10)
      }
    }

    function filter () {
        workplanReviewVM.gridApi.grid.refresh();
    }

    function singleFilter(renderableRows){
      var matcher = new RegExp(workplanReviewVM.workPlanFilter, 'i');
      renderableRows.forEach( function( row ) {
        var match = false;
        [ 'ds_name', 'workplan_name' ].forEach(function( field ){
          if ( row.entity[field] && row.entity[field].match(matcher) ){
            match = true;
          }
        });
        if ( !match ){
          row.visible = false;
        }
      });
      return renderableRows;
    };

    activate()

    function activate(){
        //getListItems()
        workplanReviewVM.gridOptions.data = listJson()
        
    }

    function getListItems () {
        let params = {
            id_user: JSON.parse($cookies.get('currentUser')),
            is_review: 2,
            is_rejected: null
        }
        WorkPlanSrv.getWorkPlansInReview.get(params).$promise.then((dataReturn) => {
            if (dataReturn.status === true) {
            workplanReviewVM.gridOptions.data = dataReturn.data
            } else {
            console.log(dataReturn)
            }
        }).catch((err) => {
            console.log('Error: ', err)
        })
    }

    function listJson(){
      var dataList = [
          {
            ds_name: 'Enrique Diaz',
            workplan_name: 'Plan de trabajo A 2017',
            state_name: 'Planeacion Terminada',
            id_state: 1
          },{
            ds_name: 'Alexandra Neira',
            workplan_name: 'Plan de trabajo A 2017',
            state_name: 'Planeacion Terminada',
            id_state: 1
          },{
            ds_name: 'Enrique Diaz',
            workplan_name: 'Plan de trabajo A 2017',
            state_name: 'Planeacion Terminada',
            id_state: 1
          },{
            ds_name: 'Enrique Diaz',
            workplan_name: 'Plan de trabajo A 2017',
            state_name: 'Planeacion Terminada',
            id_state: 1
          },{
            ds_name: 'Enrique Diaz',
            workplan_name: 'Plan de trabajo A 2017',
            state_name: 'Planeacion Terminada',
            id_state: 1
          },{
            ds_name: 'Enrique Diaz',
            workplan_name: 'Plan de trabajo A 2017',
            state_name: 'Planeacion Terminada',
            id_state: 1
          },{
            ds_name: 'Enrique Diaz',
            workplan_name: 'Plan de trabajo A 2017',
            state_name: 'Planeacion Terminada',
            id_state: 1
          },
        ]
        return dataList
    }
  }
}

WorkPlanReviewPhaseCtrl.$inject = ['$scope', '$timeout', '$stateParams', 'WorkPlanSrv', '$cookies', '$rootScope','$interval']





// WEBPACK FOOTER //
// ./src/app/u-faculty/workplan/start/reviewPhase/workplanReviewPhaseCtrl.js